exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#action{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:end}.sort-border{border-top:2px solid #2c2d2f}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/module/special-components/Table-component/Table-Transfer.vue"],"names":[],"mappings":"AACA,QACE,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACf,mBAAqB,CAC1B,AACD,aACE,4BAA8B,CAC/B","file":"Table-Transfer.vue","sourcesContent":["\n#action {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: end;\n}\n.sort-border {\n  border-top: 2px solid #2c2d2f;\n}\n"],"sourceRoot":""}]);

// exports
